import {
  SET_USER_PROFILE,
  SET_USER_PROFILE_FAILED_ACTION,
} from "../actions/actionTypes";
import {
  LOADING_TOGGLE_ACTION,
  LOGIN_CONFIRMED_ACTION,
  LOGIN_FAILED_ACTION,
  LOGOUT_ACTION,
  SIGNUP_CONFIRMED_ACTION,
  SIGNUP_FAILED_ACTION,
} from "../actions/AuthActions";

const initialState = {
  userInfo: {},
  token: "",
  expireIn: "",
  errorMessage: "",
  successMessage: "",
  showLoading: false,
};

// Retrieve token & expiry from localStorage only once
const getUserDetails = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  return { token: userDetails.token || "", expireIn: userDetails.expireIn || "" };
};

export function AuthReducer(state = initialState, action) {
  switch (action.type) {
    case SIGNUP_CONFIRMED_ACTION:
      return {
        ...state,
        userInfo: action.payload,
        errorMessage: "",
        successMessage: "Signup Successfully Completed",
        showLoading: false,
      };

    case LOGIN_CONFIRMED_ACTION:
      return {
        ...state,
        token: action.payload.token,
        expireIn: action.payload.expireIn,
        errorMessage: "",
        successMessage: "Login Successfully Completed",
        showLoading: false,
      };

    case LOGOUT_ACTION:
      return {
        ...initialState, // Reset state on logout
      };

    case LOADING_TOGGLE_ACTION:
      return {
        ...state,
        showLoading: action.payload,
      };

    case SET_USER_PROFILE: {
      const { token, expireIn } = getUserDetails();
      return {
        ...state,
        token,
        expireIn,
        userInfo: action.payload,
        errorMessage: "",
        successMessage: "Profile Set Successfully Completed",
        showLoading: false,
      };
    }

    case SIGNUP_FAILED_ACTION:
    case LOGIN_FAILED_ACTION:
    case SET_USER_PROFILE_FAILED_ACTION:
      return {
        ...state,
        errorMessage: action.payload,
        successMessage: "",
        showLoading: false,
      };

    default:
      return state;
  }
}
